/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import SimpliCityAdminSDK from "@simplicitycms/simplicity-admin-js-sdk";
import SimpliCityPublicSDK from "@simplicitycms/simplicity-js-sdk";
import { CmsConfig } from "cms/config";

export const SimpliCitySDK = CmsConfig.isPreview ? SimpliCityAdminSDK : SimpliCityPublicSDK;
